<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="800px">
    <v-card>
      Map coming soon
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'MapDialog',
    props: ['value'],
    components: {},
    watch: {
      value() {
        this.reset();
      },
    },
    computed: {},
    methods: {
      close() {
        this.reset();
        this.$emit('input', false);
      },
      reset() {},
    },
    data() {
      return {};
    },
  };
</script>
